export default __webpack_public_path__ + "static/media/medal-3.14a89da7.svg";